// src/components/ListSequences.js

import React from "react";
import { useAuth } from "../util/auth";
import { useSequencesByOwner, useEntityTaxonomyByOwner } from "../util/db";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

function ListSequences() {
  const auth = useAuth();
  const { data: sequences, status: seqStatus } = useSequencesByOwner(auth.user.uid);
  const { data: bridging, status: bridgingStatus } = useEntityTaxonomyByOwner("sequence", auth.user.uid);

  if (seqStatus === "loading" || bridgingStatus === "loading") {
    return <CircularProgress />;
  }
  if (!sequences) return null;

  // Build a map from sequence.id => array of tag names
  const sequenceTagsMap = {};
  if (bridging) {
    bridging.forEach((row) => {
      const arr = sequenceTagsMap[row.entity_id] || [];
      arr.push(row.taxonomy.name);
      sequenceTagsMap[row.entity_id] = arr;
    });
  }

  const handleRun = async (sequenceId) => {
    try {
      const res = await fetch("/api/run-sequence", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sequenceId }),
      });

      if (!res.ok) throw new Error(await res.text());
      // optional success toast or redirect could go here
    } catch (err) {
      alert(`Could not run sequence: ${err.message}`);
    }
  };

  return (
    <TableContainer component={Paper} style={{ marginTop: "2rem" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Prompts (IDs)</TableCell>
            <TableCell>Tags</TableCell>
            <TableCell>Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sequences.map((seq) => {
            const tags = sequenceTagsMap[seq.id] || [];
            return (
              <TableRow key={seq.id}>
                <TableCell>{seq.prompts.join(", ")}</TableCell>
                <TableCell>{tags.join(", ")}</TableCell>
                <TableCell>{seq.createdAt}</TableCell>
                <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => handleRun(seq.id)}
            >
              Run
            </Button>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ListSequences;
